import { Controller } from "@hotwired/stimulus";
import *  as Luxon from "luxon";

export default class extends Controller {
    static targets = ["startDate", "startTime", "warning"]

    connect() {
        setTimeout(() => {
            this.addEventListeners();
        })
    }

    getTimezone() {
        const timeZone = this.data.get("timezone")
        if (!timeZone) return null;

        return timeZone;
    }

    validateStartDate(date, time) {
        if (!date || !time) return;

        const timezone = this.getTimezone();
        const dateTime = Luxon.DateTime.fromISO(date + "T" + time, { zone: timezone });
        const now = Luxon.DateTime.now().setZone(timezone);

        if (this.hasWarningTarget) {
            if (dateTime < now) {
                this.warningTarget.classList.remove("hidden");
            } else {
                this.warningTarget.classList.add("hidden");
            }
        }
    }

    addEventListeners() {
        let date = ""
        let time = ""

        const startDate = this.hasStartDateTarget ? this.startDateTarget : null;
        if (startDate) {
            startDate.addEventListener("input", () => {
                date = startDate.value;
                this.validateStartDate(date, time);
            })
        }

        const startTime = this.hasStartTimeTarget ? this.startTimeTarget : null;
        if (startTime) {
            startTime.addEventListener("input", () => {
                time = startTime.value;
                this.validateStartDate(date, time);
            })
        }
    }
}